import jQuery from 'jquery';
import cookie from 'react-cookie';
import _ from 'lodash';
const NOT_FIRST_LOGIN = 'not_first_login';
const DEFAULT = 'default';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';

export const isFirstTime = () => {
  return !(cookie.load(NOT_FIRST_LOGIN));
};

const setCookieForFirstTimer = () => {
  if (isFirstTime()) {
    cookie.save(NOT_FIRST_LOGIN, true);
  }
};

export const externalRegister = (authType, accessToken, errorCallback) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/application/index/ajax-registration',
    data: {authType: authType, accessToken: accessToken},
  }).fail(console.error.bind(console, 'register'))
    .then((result) => {
      if (result.redirect) {
        setCookieForFirstTimer();
        window.location.replace(result.redirect);
      } else {
        errorCallback(result);
      }
    });
};

export const register = (email, password, errorCallback) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/application/index/ajax-registration',
    data: {email: email, password: password, authType: DEFAULT},
  }).fail(console.error.bind(console, 'register'))
    .then((result) => {
      if (result.redirect) {
        setCookieForFirstTimer();
        window.location = result.redirect;
      } else {
        errorCallback(result);
      }
    });
};

export const externalLogin = (authType, email, password, accessToken, redirect, errorCallback) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/application/index/ajax-login',
    data: {authType: authType, email: email, password: password, accessToken: accessToken, redirectAfterLogin: redirect},
  }).fail(console.error.bind(console, 'login'))
    .then((result) => {
      if (result.redirect) {
        setCookieForFirstTimer();
        window.location = result.redirect;
      } else {
        errorCallback(result);
      }
    });
};

export const login = (email, password, redirectUrl, errorCallback) => {
  const noRedirectData = {email: email, password: password, authType: DEFAULT};
  return jQuery.ajax({
    method: 'POST',
    url: '/application/index/ajax-login',
    data: redirectUrl ? _.merge({}, noRedirectData, {redirectUrl: redirectUrl}) : noRedirectData,
  }).fail(console.error.bind(console, 'login'))
    .then((result) => {
      if (result.redirect) {
        setCookieForFirstTimer();
        window.location.replace(result.redirect);
      } else {
        errorCallback(result);
      }
    });
};


export const resetPassword = (email, callback) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/application/index/ajax-reset-password',
    data: {email: email},
  }).fail(console.error.bind(console, 'login'))
    .then((result) => {
      if (result.redirect) {
        window.location = result.redirect;
      } else {
        callback(result);
      }
    });
};
